declare namespace $ {

	export class $invite_app extends $invite_dict {
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map